// pages/Dashboard.jsx
import Home from "../components/homeComponents/Home";
import HomeLayout from "../components/HomeLayout";

export default function HomePage() {
  return (
    <HomeLayout>
      <Home />
    </HomeLayout>
  );
}
